import { create } from 'zustand'

export type ListenerCountError = {
  occurredAt: number
}

type ListenerCountPartial = {
  enabled?: boolean
  count?: number | null
  lastUpdated?: string | null
  stale?: boolean | null
  loading?: boolean
  hasFetched?: boolean
  error?: ListenerCountError | null
  nextRefreshAt?: number | null
}

type ListenerCountState = {
  enabled: boolean
  count: number | null
  lastUpdated: string | null
  stale: boolean | null
  loading: boolean
  hasFetched: boolean
  error: ListenerCountError | null
  nextRefreshAt: number | null
  version: number
  setState: (partial: ListenerCountPartial) => void
  bumpVersion: () => void
  reset: () => void
}

const initialState = {
  enabled: false,
  count: null,
  lastUpdated: null,
  stale: null,
  loading: false,
  hasFetched: false,
  error: null,
  nextRefreshAt: null,
  version: 0,
}

const useListenerCountStore = create<ListenerCountState>((set) => ({
  ...initialState,
  setState: (partial) => {
    set((state) => ({
      ...state,
      ...partial,
    }))
  },
  bumpVersion: () => {
    set((state) => ({
      ...state,
      version: state.version + 1,
    }))
  },
  reset: () => {
    set(initialState)
  },
}))

export default useListenerCountStore
